const UnauthorizedPage = () => {
  return <h2>Unauthorized: You do not have permission to view this page.</h2>;
};
export default UnauthorizedPage;
